import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ADOProjectPicker } from './ADOProjectPicker';

export const ADOProjectPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ADOProjectPicker',
    component: ADOProjectPicker,
  }),
);
